export class EvaporatorData {
    runningHours: number;
    production: number;

    constructor(runningHours: number, production: number) {
        this.runningHours = runningHours;
        this.production = production;
    }
}
